import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SettingsService } from '../settings/service/settings.service';

@Component({
    standalone: true,
    selector: 'abs-admin-panel',
    imports: [CommonModule, IonicModule],
    encapsulation: ViewEncapsulation.ShadowDom,
    template: `
        @if (settingsService.isAdmin()) {
            <div class="admin-panel" [class.expanded]="expanded">
                <button class="admin-panel-toggle" (click)="expanded = !expanded">
                    <ion-icon [name]="expanded ? 'chevron-up-outline' : 'construct-outline'"></ion-icon>
                    <span class="admin-panel-label">{{ label }}</span>
                    @if (!expanded) {
                        <span class="admin-panel-hint">Tap to expand</span>
                    }
                </button>

                @if (expanded) {
                    <div class="admin-panel-body">
                        <div class="admin-panel-actions">
                            <button class="admin-panel-btn" (click)="hideAdminPanel()">
                                <ion-icon name="eye-off-outline"></ion-icon>
                                Hide Admin Panel
                            </button>
                        </div>

                        <slot></slot>
                    </div>
                }
            </div>
        }
    `,
    styles: [
        `
            :host {
                display: block;
            }

            .admin-panel {
                margin: 4px 0 8px;
                border-radius: 6px;
                border: 1px dashed rgba(0, 0, 0, 0.15);
                background: rgba(255, 255, 255, 0.85);
                overflow: hidden;
                font-size: 0.82em;
                color: #333;
            }

            .admin-panel-toggle {
                display: flex;
                align-items: center;
                gap: 6px;
                width: 100%;
                padding: 6px 12px;
                border: none;
                background: transparent;
                cursor: pointer;
                color: #888;
                font-size: 1em;
                font-weight: 600;
                text-align: left;
            }

            .admin-panel-toggle:hover {
                background: rgba(0, 0, 0, 0.03);
            }

            .admin-panel-toggle ion-icon {
                font-size: 1.1em;
                color: #999;
            }

            .admin-panel-label {
                text-transform: uppercase;
                letter-spacing: 0.05em;
            }

            .admin-panel-hint {
                margin-left: auto;
                font-weight: 400;
                font-size: 0.85em;
                color: #aaa;
            }

            .admin-panel-body {
                padding: 4px 12px 10px;
                display: flex;
                flex-direction: column;
                gap: 8px;
            }

            .admin-panel-actions {
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
            }

            .admin-panel-btn {
                display: inline-flex;
                align-items: center;
                gap: 4px;
                padding: 4px 10px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.12);
                background: #fff;
                color: #555;
                font-size: 0.95em;
                font-weight: 500;
                cursor: pointer;
                text-decoration: none;
                transition: background 0.15s;
            }

            .admin-panel-btn:hover {
                background: rgba(0, 0, 0, 0.05);
            }

            .admin-panel-btn ion-icon {
                font-size: 1.1em;
            }
        `
    ]
})
export class AdminPanelComponent {
    @Input() label = 'Admin';

    expanded = false;

    constructor(public settingsService: SettingsService) {}

    hideAdminPanel() {
        this.settingsService.hideAdminForSession();
    }
}
